import { useRef, useState, useEffect, useContext } from 'react';
import AuthContext from "./AuthProvider";
import AuthService from "../../services/auth.service";
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Typography, Space, Spin } from 'antd';
import axios from './axios';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import './login.css';
import Password from 'antd/lib/input/Password';
const LOGIN_URL = 'http://85.159.27.198:8080/abitur/api/auth/signin';

const Login = (props) => {
    const form = useRef();
    const checkBtn = useRef();
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const navigate = useNavigate();

    const onChangeUsername = (e) => {
        const username = e.target.value;
        setUsername(username);
      };
    
      const onChangePassword = (e) => {
        const password = e.target.value;
        setPassword(password);
      };

    const handleLogin = (e) => {
        
        // e.preventDefault();
    
        setMessage("");
        setLoading(true);
    
        // form.current.validateAll();
        
        // if (checkBtn.current.context.errors.length === 0) {
          AuthService.login(username, password).then(
            () => {
              //props.history.push("/profile");
              navigate('/home');
            window.location.reload();
              console.log("121212");
            },
            (error) => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
    
              setLoading(false);
              setMessage(resMessage);
            }
          );
        // } else {
        //   setLoading(false);
        // }
      };


    return (
        <>
            {success ? (
                <section>
                    <h1>You are logged in!</h1>
                    <br />
                    <p>
                        <a href="#">Go to Home</a>
                    </p>
                </section>
            ) : (
                
                <div className="main-container">
      <div className="logo-container"></div>
      <div className="form-container">
        <Form className="form-itself" wrapperCol={{ span: 10, offset: 7 }} onFinish={handleLogin} ref={form}>
          <Form.Item name="username">
                        <Input
                        type="text"
                        size="large"
              prefix={<UserOutlined style={{ color: 'grey' }} />}
              placeholder="Username"
                        name="username"
                        value={username}
                        onChange={onChangeUsername}
                        required
                        />
                    </Form.Item>
                    <Form.Item  name="password"
                        value={password}
                        onChange={onChangePassword}>
                    <Password size="large" prefix={<LockOutlined style={{ color: 'grey' }} />} placeholder="Password"  
                        required/>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
              Log in
            </Button>
          </Form.Item>
                    
          </Form> 

                    {message && (
                        <div className="form-group">
                        <div className="alert alert-danger" role="alert">
                            {message}
                        </div>
                        </div>
                    )}
                    <button style={{ display: "none" }} ref={checkBtn} />
                    
                </div>
                </div>
            )}
        </>
    )
}

export default Login
